export default __webpack_public_path__ + "static/media/close-filter.e943deda.svg";